const LOCAL_STORAGE_KEY_LAST_ACTIVE_REQUEST = 'lastActiveRequest';

export default function LogoutWarnings(settings, setModal) {
    const initLogoutWarnings = () => {
        const timer14Mins = setInterval(() => {
            if (loggedOutWarning()) {
                clearInterval(timer14Mins);
            }
        }, 1000);

        const timer15Mins = setInterval(() => {            
            if (expiredCheck(settings.timeout * 1000)) {
                clearInterval(timer15Mins);
                window.location = '/login/terminate';
            }        
        }, 1000);
    }
        
    const expiredCheck = (timeout) => {
        var lastUpdated = parseInt(localStorage.getItem(LOCAL_STORAGE_KEY_LAST_ACTIVE_REQUEST)) + timeout;
        var now = (new Date).getTime();
 
        return (now > lastUpdated);
    }
    
    const loggedOutWarning = () => {       
        if (expiredCheck((settings.timeout - 60) * 1000)) {    
            setModal(true);
            return true;
        }
    }

    return !settings.guest ? initLogoutWarnings() : null;
}